import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TurnedInNotIcon(props: IconProps) {
    return <Icon {...props} iconKey={"turned_in_not"}/>
}
